import React from 'react';

const Drums = () => {
    return (
      <React.Fragment>
        <div className="btn__base r3c2">
          <div className="btn">
            <div className="mark">
              <div className="mark__1">⦿</div>
              <div className="mark__2"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  export default Drums;